import type { FC } from 'react';
import { useSelector } from 'react-redux';
import SelectionArea from '../../_partials/SelectionArea';
import StudioSearchBar from '../../../StudioSearchBar';
import Pagination from '../../../StudioPagination';
import TableLayoutSelector from '../../../TableLayoutSelector';
import { StudioSection } from '../../../../types/store';
import { SelectionProps } from '../../types';
import {
  getIsGridLayoutSupported,
  getIsPublishedSection,
  getIsRootFolder,
  getStudioParams,
} from '../../../../selectors/studio';
import { SEARCHABLE_SECTIONS } from '../../../../../constants';

import s from './DefaultLayout.scss';

export interface Props extends SelectionProps {
  activeSection: StudioSection;
}

const DefaultLayout: FC<Props> = ({
  activeSection,
  ...selectionProps
}) => {
  const isRootFolder = useSelector(getIsRootFolder);
  const isGridLayoutSupported = useSelector(getIsGridLayoutSupported);
  const isPublishedSection = useSelector(getIsPublishedSection);
  const { contentType } =useSelector(getStudioParams);
  const isSearchable = isPublishedSection
    ? (isRootFolder && contentType !== 'posts')
    : SEARCHABLE_SECTIONS.includes(activeSection);

  return (
    <div className={s['root']}>
      <SelectionArea {...selectionProps} className={s['selection']} />
      {isSearchable && <StudioSearchBar className={s['search-bar']} />}
      <div className={s['right']}>
        {isGridLayoutSupported && <TableLayoutSelector />}
        <Pagination
          onFetchSuccess={() => window.scrollTo({ top: 0 })}
          showResultsCount={false}
        />
      </div>
    </div>
  );
};
DefaultLayout.displayName = 'DefaultLayout';

export default DefaultLayout;
